<div class="component-modal-header">
  <span class="modal-title">Choose work order or site session</span>
  <button type="button" class="close" aria-label="Close" (click)="closeModal()"><span class="pi pi-times"></span></button>
</div>

<div class="modal-body">
  <div class="mb-2 animated fadeIn">

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group form-group-checkbox">
            <label>Site Session</label>
            <p-checkbox class="form-control" formControlName="isSiteSession" binary="true"></p-checkbox>
          </div>
        </div>
      </div>
      <br>

      <ng-container *ngIf="!form.value.isSiteSession">
        <div class="row">
          <div class="col-md-12" *ngIf="assets.length">
            <div class="form-group">
              <label>Select Asset <span class="required-star">*</span></label>
              <p-dropdown class="pDropdownCustom"
                formControlName="asset"
                (ngModelChange)="onSelectedAssetChange($event)"
                [ngModelOptions]="{ standalone: true }"
                [options]="assets"
                optionLabel="label"
                [style]="{ width: '100%' }"
                placeholder="Select an asset..."
                filter="true"
                >
                <ng-template let-option let-i="index" pTemplate="item">
                  {{option.label}} <i *ngIf="option.locked" class="fa fa-lock danger"></i>
                </ng-template>
                <ng-template let-option let-i="index" pTemplate="selectedItem">
                  {{option.label}} <i *ngIf="option.locked" class="fa fa-lock danger"></i>
                </ng-template>
              </p-dropdown>
            </div>
          </div>
        </div>
        <br>

        <div class="row">
          <div class="col-md-12">
            <div class="form-group">

              <div class="filter-flex-row">
                <div>
                  <label>Work Order <span class="required-star">*</span></label>
                </div>
                <span *ngIf="isWorkOrdersLoading" class="small-spinner-inline">
                  <p-progressSpinner [strokeWidth]="5"></p-progressSpinner>
                </span>
              </div>

              <ng-container *ngIf="workOrders.length">
                <p-dropdown class="form-control"
                  formControlName="workOrder"
                  [options]="workOrders"
                  [style]="{ width: '100%' }"
                  placeholder="Select a work order ..."
                  filter="true"
                >
                  <ng-template let-option let-i="index" pTemplate="item">
                    <div class="d-flex justify-content-between">
                      {{option.label}}
                      <work-order-state-badge *ngIf="option.value" [workOrder]="option.value"></work-order-state-badge>
                    </div>
                  </ng-template>
                </p-dropdown>
              </ng-container>

              <ng-container *ngIf="!form.value.asset">
                <p-dropdown class="form-control" [disabled]="true" placeholder="Select an asset"></p-dropdown>
              </ng-container>
              <ng-container *ngIf="form.value.asset && !workOrders.length">
                <p-dropdown class="form-control" [disabled]="true" placeholder="No available work orders found for this asset"></p-dropdown>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </form>

    <p-footer>
      <button type="button" [disabled]="!form.value.isSiteSession && !form.value.workOrder " (click)="onSubmit()" class="btn btn-sm btn-success">Save</button>
      <button type="button" (click)="closeModal()" class="btn btn-sm btn-default">Cancel</button>
    </p-footer>
  </div>
</div>
